import Box from "@cloudscape-design/components/box";
import Button from "@cloudscape-design/components/button";
import SpaceBetween from "@cloudscape-design/components/space-between";
import { useState } from "react";
import { usePublicConfig } from "../api/queries";
import { startGoogleSignIn } from "../lib/google-sign-in";

interface GoogleSignInButtonProps {
  referralCode?: string;
  remember?: boolean;
}

/**
 * "Tiếp tục với Google", kèm vạch "hoặc" ngăn với form email bên dưới.
 *
 * Không vẽ gì khi máy chủ chưa bật Google (`public-config.google.enabled`): một
 * nút bấm ra lỗi "chưa cấu hình" là tệ hơn không có nút.
 */
export function GoogleSignInButton({ referralCode = "", remember = true }: GoogleSignInButtonProps) {
  const { data: config } = usePublicConfig();
  const [leaving, setLeaving] = useState(false);
  const clientId = config?.google?.enabled ? config.google.client_id || "" : "";
  if (!clientId) return null;
  return (
    <SpaceBetween size="l">
      <Button
        fullWidth
        iconSvg={<GoogleMark />}
        loading={leaving}
        loadingText="Đang mở Google"
        onClick={() => {
          setLeaving(true);
          startGoogleSignIn(clientId, { referralCode, remember });
        }}
      >
        Tiếp tục với Google
      </Button>
      <Box textAlign="center" color="text-body-secondary" fontSize="body-s">hoặc dùng email</Box>
    </SpaceBetween>
  );
}

/** Chữ G bốn màu theo quy định thương hiệu của Google — không đổi theo token màu. */
export function GoogleMark() {
  return (
    <svg viewBox="0 0 48 48" focusable="false" aria-hidden="true">
      <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z" />
      <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z" />
      <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z" />
      <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z" />
    </svg>
  );
}
